export { default } from "./ShopAllButton";
